import { useState } from 'react';
import { Sparkles, Loader2, ChevronDown, ChevronUp, X } from 'lucide-react';

interface DraftBannerProps {
  draftCount: number;
  agentType: string;
  loading?: boolean;
  onApplyDrafts: () => void;
  onDismissDrafts?: () => void;
}

export function DraftBanner({ draftCount, agentType, loading, onApplyDrafts, onDismissDrafts }: DraftBannerProps) {
  const [expanded, setExpanded] = useState(true);

  if (draftCount === 0) return null;

  return (
    <div className="mb-6 rounded-xl border border-[#05E0D1]/30 bg-gradient-to-r from-[#05E0D1]/[0.06] to-[#1875FF]/[0.06] overflow-hidden shadow-sm">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-5 py-3.5"
      >
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#05E0D1] to-[#1875FF] flex items-center justify-center shadow-sm">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-gray-900">
              {draftCount} Generated Script{draftCount > 1 ? 's' : ''} Available
            </p>
            <p className="text-xs text-gray-500 mt-0.5">
              From Sales Playbook — review and apply to activate
            </p>
          </div>
        </div>
        {expanded ? (
          <ChevronUp className="w-5 h-5 text-[#05E0D1]" />
        ) : (
          <ChevronDown className="w-5 h-5 text-[#05E0D1]" />
        )}
      </button>

      {expanded && (
        <div className="px-5 pb-4 flex items-center gap-3">
          <button
            onClick={onApplyDrafts}
            disabled={loading}
            className="px-4 py-2 bg-gradient-to-r from-[#1875FF] to-[#05E0D1] text-white rounded-lg text-sm font-semibold hover:shadow-md hover:scale-[1.02] transition-all disabled:opacity-50 flex items-center gap-2"
          >
            {loading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <Sparkles className="w-4 h-4" />
            )}
            Apply Generated Scripts
          </button>
          {onDismissDrafts && (
            <button
              onClick={onDismissDrafts}
              className="px-4 py-2 border border-gray-300 text-gray-600 rounded-lg text-sm font-medium hover:bg-gray-50 transition-all flex items-center gap-1.5"
            >
              <X className="w-3.5 h-3.5" />
              Keep Current Scripts
            </button>
          )}
          <span className="text-xs text-gray-500">
            Applying will replace your current templates
          </span>
        </div>
      )}
    </div>
  );
}
